// PLACEHOLDER DATA — replace with Supabase query.
// All active programs. Ordered as specified.

export type Season = "Fall" | "Winter" | "Spring" | "Summer" | "evergreen";

export interface RegisterProduct {
  id: string;
  name: string;
  price: number | string;
  dateRange: string;
  description: string;
  season: Season;
  /** Texto del boton. Si viene vacio se usa el texto por defecto. */
  ctaLabel?: string;
  /** Marca alterna de la tarjeta. "a1" = Athletes First. */
  accent?: string;
  ctaLink: string;
  badge?: string;
  imageUrl?: string;
  ctaStyle?: "primary" | "secondary";
  priceNote?: string;
  footnote?: string;
}

export const registerProducts: RegisterProduct[] = [
  {
    id: "reg-winter-2026-boys",
    name: "Winter Season 2026-2027 (5th - 12th)",
    price: "$1,575",
    dateRange: "November 2026 — February 2027",
    description:
      "Boys from 5th to 12th grade. Four to five workouts a week across 20 weeks, league play and an expected 20 games.",
    season: "Winter",
    ctaLink: "https://app.triumphbasketball.com/auth/login",
    badge: "REGISTRATION OPEN",
    ctaStyle: "primary",
    priceNote: "Per season",
    footnote:
      "Uniform not included. All players need a new uniform this season, ordered through Under Armour or Not Just Soccer Team Link. Under Armour basketball shoes and UA Gear Packet required. Ordering link coming soon.",
    imageUrl:
      "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/Gemini_Generated_Image_335aih335aih335a.webp",
  },
  {
    id: "reg-winter-2026-practice",
    name: "Winter Season '26-'27- Practice Only (5th-12th)",
    price: "$1,240",
    dateRange: "November 2026 — February 2027",
    description:
      "Boys from 5th to 12th grade. Four to five workouts a week across 20 weeks.",
    season: "Winter",
    ctaLink: "https://app.triumphbasketball.com/auth/login",
    badge: "REGISTRATION OPEN",
    ctaStyle: "primary",
    priceNote: "Per season",
    imageUrl:
      "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/tryout-combine-real.jpg",
  },
  {
    id: "reg-winter-2026-k4",
    name: "Winter Season 2026-2027 (K-4th)",
    price: "$900",
    dateRange: "November 2026 — February 2027",
    description:
      "Boys from K to 4th grade. Two to three workouts a week across 20 weeks, and an expected 20 games.",
    season: "Winter",
    ctaLink: "https://app.triumphbasketball.com/auth/login",
    badge: "REGISTRATION OPEN",
    ctaStyle: "primary",
    priceNote: "Per season",
    imageUrl:
      "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/fall-season-boys.jpg",
  },
  {
    id: "reg-winter-2026-practice-k4",
    name: "Winter Season '26-'27 - Practice Only (K-4th)",
    price: "$715",
    dateRange: "November 2026 — February 2027",
    description:
      "Boys from K to 4th grade. Two to three workouts a week across 20 weeks.",
    season: "Winter",
    ctaLink: "https://app.triumphbasketball.com/auth/login",
    badge: "REGISTRATION OPEN",
    ctaStyle: "primary",
    priceNote: "Per season",
    imageUrl:
      "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/fall-practice-only-real.jpg",
  },
  {
    id: "reg-evergreen-pl4",
    name: "Private Lesson Pack",
    price: 240,
    dateRange: "Book Anytime",
    description:
      "Four one-hour private lessons at your home or a local court. Shooting mechanics, ball handling, footwork, and defensive positioning, built around accountability.",
    season: "evergreen",
    ctaLink: "https://app.triumphbasketball.com/auth/login",
    badge: "ALWAYS OPEN",
    priceNote: "Per 4-lesson pack",
    imageUrl:
      "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/private-training-coach-01.jpg",
  },
  {
    id: "reg-girls-athletes-first",
    name: "Girls — Athletes First",
    price: "",
    dateRange: "November 2026 — February 2027",
    description:
      "Triumph girls now play with Athletes First, our sister club. Grades 3-12, PSA league play plus three tournaments. Enrollment is open now.",
    season: "evergreen",
    ctaLabel: "Visit Athletes First",
    accent: "a1",
    ctaLink: "https://athletes1sttx.com",
    badge: "GIRLS PROGRAM",
    ctaStyle: "primary",
    imageUrl:
      "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/a1-girls-card.webp",
  },
];
